import React, { PureComponent } from 'react';
import Card from '@mui/material/Card';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { TextInput, required, SimpleForm } from 'react-admin';
import { useNavigate, useLocation } from 'react-router-dom';
import { validatePassword } from '../../../utils/validators';
import dataProvider from '../../../providers/dataProvider';
import ToolbarResetPassword from './ToolbarResetPassword';
import { styles } from '../styles';

const style = (theme) => {
  return {
    ...styles,
    icon: {
      backgroundColor: theme.palette.secondary.main,
    },
    hint: {
      marginTop: '1em',
      display: 'flex',
      justifyContent: 'center',
      color: theme.palette.grey[500],
    },
    form: {
      textAlign: 'center',
    },
    button: {
      display: 'block',
      margin: '20px auto 0px auto',
    },
    errors: {
      color: theme.palette.error.main,
    },
  };
};

const validateConfirmPassword = (value, allValues) => {
  if (allValues.password !== allValues.passwordConfirm) {
    return 'The password shoud be equal "password"';
  }
  return undefined;
};

const validatePasswordPattern = (value) => {
  if (validatePassword(value)) {
    return validatePassword(value);
  }
  return undefined;
};

class ResetPassword extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      code: null,
      error: [],
    };
  }

  componentDidMount() {
    this.setState({ code: this.getJsonFromUrl().reset_code });
  }

  getJsonFromUrl = (url) => {
    if (!url) url = this.props.location?.hash || window.location.hash;

    const query = url.substr(1);
    const result = {};

    query.split('&').forEach(function (part) {
      const item = part.split('=');
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  };

  save = (data) => {
    dataProvider
      .create('account/reset_confirm', {
        data: { ...data, resetCode: this.state.code },
      })
      .then(() => {
        this.props.navigate('/login');
      })
      .catch((err) => {
        if (typeof err === 'object') {
          const errors = err
            .map((item) => {
              return item.errors.map((val) => val);
            })
            .reduce((acc, val) => acc.concat(val), []);
          this.setState({ error: errors });
        }
      });
  };

  render() {
    const { classes } = this.props;
    const { error } = this.state;
    return (
      <div className={classes.main}>
        <Card className={classes.card}>
          <div className={classes.avatar}>
            <img className={classes.logo} src="./img/logo.svg" alt="GMB Logo" />
          </div>
          <br />
          <>
            <Typography variant="headline">RESET PASSWORD</Typography>
            <Typography component="h5" align="center">
              Welcome back! You can set up a new password for your account below:
            </Typography>
            <SimpleForm
              className={classes.form}
              onSubmit={this.save}
              toolbar={<ToolbarResetPassword />}
            >
              <TextInput
                fullWidth
                type="password"
                source="password"
                label="New Password"
                validate={[required(), validatePasswordPattern]}
              />
              <TextInput
                fullWidth
                type="password"
                source="passwordConfirm"
                label="Confirm New Password"
                validate={[required(), validateConfirmPassword]}
              />
              <>
                <div className={classes.errors}>
                  {error.map((err, i) => (
                    <div key={i}>{err}</div>
                  ))}
                </div>
              </>
            </SimpleForm>
          </>
        </Card>
      </div>
    );
  }
}

// Wrapper to provide router hooks to class component
const ResetPasswordWithRouter = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  return <ResetPassword {...props} navigate={navigate} location={location} />;
};

export default withStyles(style)(ResetPasswordWithRouter);
